import { TocItem } from '@/app/shared/models';

export function getSectionParent(sectionId: string, sectionsById: { [sectionId: string]: TocItem }) {
  for (let [currentId, currentItem] of Object.entries(sectionsById)) {

    // check whether section is under its children
    const children = currentItem.children || []
    if (children.find(x => x.id === sectionId)) {
      // this is the parent of the section id
      return currentId
    }
  }

  return null
}

export function isSectionDescendantOf(childId: string,
                               anchestorId: string,
                               sectionsById: { [sectionId: string]: TocItem }) {

  let currentId = getSectionParent(childId, sectionsById);

  while (currentId) {

    if (currentId === anchestorId) {
      return true
    }

    currentId = getSectionParent(currentId, sectionsById)
  }

  return false
}
